module.exports = __webpack_public_path__ + "assets/1ab0cd0ef8488500b0cded55a34db93c.mp3";